import React from "react";

const textToHtml = (text, domain) => {
  // Regex to detect URLs (both http and https)
  const urlPattern = /(http[s]?:\/\/[^\s<>"']+)/g;
  
  // Function to replace hostname in URL
  const replaceHostname = (url, domain) => {
    try {
      const parsedUrl = new URL(url);
      return url.replace(parsedUrl.hostname, domain);
    } catch (e) {
      return url;
    }
  };
  
  // Split the text by new lines and process each line
  const lines = text.split("\n");
  
  const htmlParts = lines.map((line, index) => {
    if (line.trim()) {
      // Replace URLs with anchor tags and modify hostname
      const formattedLine = line.replace(urlPattern, (url) => {
        let newUrl =  url
        if(domain){
          newUrl = replaceHostname(url, domain);
        } 
        return `<a href="${newUrl}" target="_blank" rel="noopener noreferrer">${newUrl}</a>`;
      });
      return `<p key=${index}>${formattedLine}</p>`;
    }
    return "";
  });

  return htmlParts.join(" <br>\n");
};

const TextRenderer = ({ text, domain }) => {
  return <div dangerouslySetInnerHTML={{ __html: textToHtml(text, domain) }} />;
};

export default TextRenderer;
